import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  Layout,
  Empty,
  Row,
  Col
} from 'antd';

import { withFirebase } from 'services/firebase';
import { FirebaseWebRTCApi } from 'services/webrtc';

import { setActive, getActive, setOnCall } from 'redux/conversations';

import ConversationList from './ConversationList';
import ChatHeader from './ChatHeader';

class Chat extends React.Component {
  componentWillUnmount() {
    this.endCall();
  }

  startCall = async (item_id) => {
    await setActive(item_id)

    if (!this.props.activeConversation) return;
    if (this.props.onCall) return;

    this.props.setOnCall(true);
    

    const conversation = this._conversationRef();
    this.api = new FirebaseWebRTCApi({
      conversation,
      localVideoRef: this.localVideo,
      peerVideoRef: this.peerVideo,
    });

    this.api.initialize({ callMode: 'VIDEO' });
  }

  endCall = () => {
    if (this.api) {
      this.api.destroy();
    }

    this.props.setOnCall(false);
  }

  archiveConversation = () => {
    this._conversationRef().update({ archived: true });
    this.props.setActive(null);
  }

  _conversationRef = () => this.props.firebase.conversation(this.props.activeConversation.id);

  render() {
    return (
      <Layout.Content>

        <Layout className="main-container">
          <ConversationList 
            startCall={this.startCall}
          />
          {this._renderChatContent()}
        </Layout>
      </Layout.Content>
    );
  }

  _renderChatContent() {
    if (!this.props.activeConversation) {
      return this._renderEmpty();
    }

    return (
      <Layout.Content>
          <ChatHeader
            conversation={this.props.activeConversation}
            onCall={this.props.onCall}
            endCall={this.endCall}
            archiveConversation={this.archiveConversation}
            setActive={this.props.setActive}
          />
        <div className="video-container" >
          <Row gutter={24} className={!this.props.onCall ? 'hidden' : ''}>
            <Col span={16} offset={2}>
              <div className="video-content remote-video-height">
              <video
                  className="video-cover"
                  ref={(ref) => this.peerVideo = ref}
                  autoPlay
                  playsInline
                />
              </div>
            </Col>
            <Col span={4}>
            <div className="video-content local-video-height">
              <video
                className="video-cover"
                ref={(ref) => this.localVideo = ref}
                muted
                autoPlay
                playsInline
              />
            </div>   
            </Col>
          </Row>
        </div>
      </Layout.Content>
    );
  }

  
  _renderEmpty() {
    return (
      <div className="select-conversation">
        <Empty
          image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
          imageStyle={{
            height: 200,
          }}
          description={
            <span>
              No Conversation Selected
            </span>
          }
      className="select-conversation-empty"
        >
        </Empty>
      </div>
    );
  }
}

export default compose(
  withFirebase,
  connect(
    state => ({
      activeConversation: getActive(state),
      onCall: state.conversations.onCall,
    }),
    { setActive, setOnCall },
  )
)(Chat);
